import { render, staticRenderFns } from "./view_dna_api.vue?vue&type=template&id=2b9d8b9a&"
import script from "./view_dna_api.vue?vue&type=script&lang=js&"
export * from "./view_dna_api.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports